module.exports = __webpack_public_path__ + "static/media/sample_rail_bulk_force_close.3de6ff3c.csv";